import ky, { HTTPError } from 'ky';
import { ENV } from 'src/utils/env';
import { STORES_CONFIG_POST_RESPONSE_SCHEMA, STORES_CONFIG_SCHEMA, StoreConfigSchema } from './storesSchema';

export const createOrUpdateStoresPromise = async (params: StoreConfigSchema) => {
  const parsedParams = STORES_CONFIG_SCHEMA.safeParse(params);

  if (!parsedParams.success) {
    throw new Error('invalid params');
  }

  try {
    const response = await ky.post(`${ENV.FRONTEND_API_URL}/stores`, {
      body: JSON.stringify(parsedParams.data),
    });

    const validatedResponse = STORES_CONFIG_POST_RESPONSE_SCHEMA.safeParse(await response.json());

    if (!validatedResponse.success) {
      console.error('Error in Response');
      throw new Error('Error in Response', validatedResponse.error);
    }

    return validatedResponse.data.data.message;
  } catch (error) {
    if (error instanceof HTTPError) {
      let errorRes = error;

      try {
        errorRes = await error.response.json();
      } catch {
        //
      }

      return errorRes?.data?.message;
    }

    throw new Error((error as Error)?.message || 'Error while creating or updating store');
  }
};
